import { render } from "./FooterNew.vue?vue&type=template&id=47e116bc&scoped=true"
import script from "./FooterNew.vue?vue&type=script&lang=js"
export * from "./FooterNew.vue?vue&type=script&lang=js"

import "./FooterNew.vue?vue&type=style&index=0&id=47e116bc&lang=scss"
import "./FooterNew.vue?vue&type=style&index=1&id=47e116bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e116bc"]])

export default __exports__